import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import ProcessTimeline from './components/ProcessTimeline';
import Gallery from './components/Gallery';
import VideoSection from './components/VideoSection';
import Benefits from './components/Benefits';
import Pricing from './components/Pricing';
import Reviews from './components/Reviews';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingPhone from './components/FloatingPhone';

function App() {
  return (
    <div className="font-sans text-neutral-darkNavy bg-white selection:bg-primary-orange selection:text-white">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <ProcessTimeline />
        <Gallery />
        <VideoSection />
        <Benefits />
        <Pricing />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <FloatingPhone />
    </div>
  );
}

export default App;
